/**
 * Viewed signup page.
 */
export function signupPage() {
  window.analytics.page('Signup')
}

/**
 * Track user signed up.
 *
 * @param {Object} user User object
 * @param {Object} data Form data
 */
export function signedUp(user, data) {
  // https://segment.atlassian.net/browse/INT-581
  // Workaround an unexpected behavior in `analytics.js` where changing userId
  // via `identify` also changes the `anonymousId`, which breaks our ability to link
  // userIds together via anonymousId (needed due to userId reservation).
  // This hacks around that behavior by saving anonymousId to a local variable,
  // call `identify`, then set the anonymousId back to the original anonymousId prior to calling `identify`.
  let anonymousId = null
  // We also need to protect against `window.analytics.user` is not a function
  // Not sure why needed, but see https://github.com/segmentio/app/pull/2206/files#r74857096
  if (typeof window.analytics.user === 'function') {
    anonymousId = window.analytics.user().anonymousId()
  }

  window.analytics.alias(user.id, {
    providers: {
      all: false,
      Mixpanel: true
    }
  })

  window.analytics.identify(user.id, {
    created: user.created,
    name: user.name,
    email: user.email,
    ...data
  })

  if (anonymousId) {
    window.analytics.user().anonymousId(anonymousId)
  }

  window.analytics.track('User Signed Up', {
    type: data ? data.type : null,
    source: data ? data.source : null
  })
}

/**
 * Identify call w/ enriched data
 *
 * @param {String} email; email address
 * @param {Object} traits; user enriched traits
 */

export function identifyCall(email, traits) {
  window.analytics.identify({
    alexaGlobalRank: traits.alexa,
    country: traits.country,
    email: email,
    employees: traits.company_size,
    industry: traits.industry_detail,
    raised: traits.raised,
    sector: traits.sector,
    seniority: traits.seniority,
    tech: traits.tech
  })
}

/**
 * Track call fires onChange of email field
 */

export function emailCaptured(email) {
  window.analytics.track('Email Captured', {
    email,
    form: 'signup'
  })
}

/**
 * Tracks when user clicks next button in signup funnel
 *
 * @param {String} email What is the user's email address
 * @param {String} step What step in the funnel user is on
 * @param {Boolean} isCompany Whether user indicated they are signing up for their co
 * @param {String} either 'team' or 'developer'
 */

export function signupNextClicked(email, step, isCompany, plan) {
  window.analytics.track('Signup Next Clicked', {
    email,
    step,
    is_company: isCompany,
    plan
  })
}
